import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';

export function SectionHeader(props: TypographyProps) {
  return (
    <Typography
      variant="h2"
      {...props}
      sx={{
        mb: 3,
        ...props.sx,
      }}
    />
  );
}
